@if (isLoading) {
  <div style="padding: 40px; text-align: center;">Loading mixing child ticket...</div>
}
@if (!isLoading && !data) {
  <div style="padding: 40px; text-align: center; color: #8c8c8c;">
    Mixing child ticket not found.
    <br>Master Batch: {{ masterMixBatchNumber }}
    <br>Child Ticket: {{ mixingChildTicketNumber }}
  </div>
}
@if (data) {
<div class="ticket-page">
  <app-print-company-header title="Mixing Child Ticket">
    <div class="batch-qr">
      <nz-qrcode [nzValue]="data.CompositeBatchNumber" [nzSize]="96" [nzBordered]="false" [nzLevel]="'M'"></nz-qrcode>
      <div class="batch-no">{{ data.CompositeBatchNumber }}</div>
    </div>
  </app-print-company-header>

  <table class="metadata-table">
    <tr>
      <td class="meta-label">Master Batch</td>
      <td class="meta-value">{{ data.MasterMixBatchNumber }}</td>
      <td class="meta-label">Date</td>
      <td class="meta-value">{{ data.TicketDate | DatetimeConverter }}</td>
    </tr>
    <tr>
      <td class="meta-label">From Vessel</td>
      <td class="meta-value">{{ data.FromVesselTag }}</td>
      <td class="meta-label">Destination Vessel</td>
      <td class="meta-value">{{ data.DestinationVesselTag }} / {{ data.DestinationVesselName }}</td>
    </tr>
    <tr>
      <td class="meta-label">Paste Color</td>
      <td class="meta-value">{{ data.PasteColor }}</td>
      <td class="meta-label">Mixing Stage</td>
      <td class="meta-value">{{ mixingLabel }}</td>
    </tr>
    @if (data.UseByDate) {
      <tr>
        <td class="meta-label">Use by</td>
        <td class="meta-value" colspan="3">{{ data.UseByDate | DatetimeConverter }}</td>
      </tr>
    }
  </table>

  <h4 class="section-title">Orders Covered</h4>
  <table class="orders-table">
    <thead>
      <tr>
        <th>S.No</th>
        <th>SO Number</th>
        <th>Customer</th>
        <th>Fabric Color</th>
        <th>Order Qty</th>
        <th>Paste (Kg)</th>
        @if (data.Pigments?.length) {
          <th>Pigment Share (Kg)</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (o of data.OrdersCovered; track $index) {
        <tr>
          <td>{{ $index + 1 }}</td>
          <td>{{ o.SaleOrderNumber }}</td>
          <td>{{ o.CustomerName }}</td>
          <td>{{ o.FabricColor }}</td>
          <td>{{ o.OrderQuantity | number:'1.2-2' }}{{ o.OrderUnit ? ' ' + o.OrderUnit : '' }}</td>
          <td><b>{{ o.PasteKg | number:'1.2-2' }}</b></td>
          @if (data.Pigments?.length) {
            <td><b>{{ o.PigmentShareKg | number:'1.2-2' }}</b></td>
          }
        </tr>
      }
    </tbody>
  </table>
  <div class="paste-total">Paste to transfer: <b>{{ data.PasteTransferQuantity | number:'1.2-2' }} Kg</b></div>

  @if (data.PasteContent?.length) {
    <h4 class="section-title">Paste content (share of master {{ data.MasterMixBatchNumber }})</h4>
    <table class="materials-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Material</th>
          <th>Kg in this ticket</th>
        </tr>
      </thead>
      <tbody>
        @for (c of data.PasteContent; track $index) {
          <tr>
            <td>{{ $index + 1 }}</td>
            <td>{{ c.ProductName }}</td>
            <td><b>{{ c.Kg | number:'1.2-2' }}</b></td>
          </tr>
        }
      </tbody>
    </table>
  }

  <h4 class="section-title">Pigments</h4>
  @if (!data.Pigments?.length) {
    <p>No pigment added on this child ticket &mdash; transfer only.</p>
  } @else {
    <table class="materials-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Pigment</th>
          <th>Batch</th>
          <th>Supplier</th>
          <th>Required (Kg)</th>
          <th>Allocated (Kg)</th>
        </tr>
      </thead>
      <tbody>
        @for (p of data.Pigments; track $index) {
          <tr>
            <td>{{ $index + 1 }}</td>
            <td>{{ p.ProductName }}</td>
            <td>{{ p.Batch }}</td>
            <td>{{ p.SupplierName }}</td>
            <td>{{ p.RequiredQuantity | number:'1.2-2' }}</td>
            <td><b>{{ p.AllocatedQuantity | number:'1.2-2' }}</b></td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (data?.UnplannedAdditions?.length) {
    <table class="materials-table" style="margin-top: 8px;">
      <thead>
        <tr class="materials-header">
          <th>S.No</th><th>Unplanned RM addition</th><th>Batch</th><th>Quantity (kg)</th><th>Unit</th>
        </tr>
      </thead>
      <tbody>
        @for (a of data.UnplannedAdditions; track $index; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ a.ProductName }}<div style="font-size: 10px; color: #595959;">{{ a.ReasonLabel }} · {{ a.AddedDate | DatetimeConverter }} · {{ a.AddedByName }}</div></td>
            <td>@for (b of a.Batches; track $index) { <div>{{ b }}</div> } @empty { — }</td>
            <td>{{ a.Quantity | number:'1.2-2' }}</td>
            <td>{{ a.Unit }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  <div class="supervisor">
    @if (data.TransferredByName) {
      <div>Transferred by: {{ data.TransferredByName }}</div>
    }
    @if (data.MixerWorkerName) {
      <div>Mixer Worker: {{ data.MixerWorkerName }}</div>
    }
    <div class="signature-line">Signature: ____________________</div>
  </div>
  <app-print-footer audience="internal"></app-print-footer>
</div>
}
